export default "__VITE_ASSET__7vbM8K08__"